/*
 * @description:
 * @author: Jason Wong
 * @since: 2020-05-07 11:54:30
 */
import layout from "../../views/layout/Layout";
import wsTest from "../../views/test/ws.vue";
import wsMsgTest from "../../views/test/wsMsg.vue";
import xlsxTest from "../../views/test/xlsxPreview.vue";

export default {
  path: "/test",
  name: "testRoute",
  component: layout,
  meta: { title: "测试" },
  children: [
    {
      path: "ws",
      name: "wsTest",
      component: wsTest,
    },
    {
      path: "wsMsg",
      name: "wsMsg",
      component: wsMsgTest,
    },
    {
      path: "xlsx",
      name: "xlsx",
      component: xlsxTest,
    },
  ],
};
